import { render, staticRenderFns } from "./ReporteBonosGeneral.vue?vue&type=template&id=480b1201&"
import script from "./ReporteBonosGeneral.vue?vue&type=script&lang=js&"
export * from "./ReporteBonosGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports